import React, { Component, Fragment } from 'react';
import { Field, withFormik } from 'formik';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import * as Yup from 'yup';

import ContactModule from 'modules/contact';
import Input from 'components/Input';
import Checkbox from 'components/Checkbox';
import Radio from 'components/Radio';
import Button from 'components/Button';
import Select from 'components/Select';
import TextArea from 'components/TextArea';
import countriesList from 'config/countries';
import statesList from 'config/states';


class ContactForm extends Component {
  render() {
    const { handleSubmit, values, handleReset, interests,
      isSending, isSended
    } = this.props;

    const countries = countriesList.map(item => {
      return {
        value: item.name,
        label: item.name,
      }
    });
    const states = statesList.map(item => {
      return {
        value: item.name,
        label: item.name,
      }
    });
    const validateRequired = (value) => {
      let error;
      if (!value) {
        error = 'Required';
      }
      return error;
    };

    return (
      <form onSubmit={handleSubmit}>
        <div className="form-section">
          <div className="title-required text-center">Required Fields<span className="title-required__sign">*</span></div>
        </div>

        <div className="form-section">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-3">
              <div className="field-wrap">
                <Field
                  name='client_type'
                  component={Radio}
                  placeholder="company"
                  radioValue="company"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <div className="field-wrap">
                <Field
                  name='client_type'
                  component={Radio}
                  placeholder="individual"
                  radioValue="individual"
                />
              </div>
            </div>
          </div>
        </div>
        {
          values.client_type === "company"
            ? (<Fragment>
              <div className="form-section">
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <div className="field-wrap">
                      <Field
                        name="name"
                        type="text"
                        placeholder="Company Name"
                        component={Input}
                        isRequired={true} />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="field-wrap">
                      <Field
                        name="title"
                        type="text"
                        placeholder="Title"
                        component={Input}
                        isRequired={true}
                        validate={validateRequired} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <div className="field-wrap">
                      <Field
                        name="contact_name"
                        type="text"
                        placeholder="Contact Name"
                        component={Input}
                        isRequired={true}
                        validate={validateRequired} />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="field-wrap">
                      <Field
                        name="email"
                        type="email"
                        placeholder="Email Address"
                        component={Input}
                        isRequired={true} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <div className="field-wrap">
                      <Field
                        name='country'
                        component={Select}
                        options={countries}
                        placeholder="Country"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="field-wrap">
                      <Field
                        name="street"
                        type="text"
                        placeholder="Street Address"
                        component={Input} />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-lg-6">
                    <div className="field-wrap">
                      <Field
                        name="city"
                        type="text"
                        placeholder="City"
                        component={Input} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3">
                    <div className="field-wrap">
                      <Field
                        name='state'
                        component={Select}
                        options={states}
                        placeholder="State"
                        isDisabled={values.country !== "United States"}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3">
                    <div className="field-wrap">
                      <Field
                        name="zip"
                        type="text"
                        placeholder="Zip code"
                        component={Input}
                        disabled={values.country !== "United States"} />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-lg-6">
                    <div className="field-wrap">
                      <Field
                        name="mobile_phone"
                        type="text"
                        placeholder="Mobile Number"
                        component={Input}
                        phoneMask={true}
                        setMask={values.country === "United States"} />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="field-wrap">
                      <Field
                        name="office_phone"
                        type="text"
                        placeholder="Office Phone"
                        component={Input}
                        phoneMask={true}
                        setMask={values.country === "United States"} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-section">
                <div className="section-title-md">Areas of Interest: Please check all that apply.</div>
                {
                  interests.map((item, index) => {
                    return (
                      <div className="field-wrap" key={item.value}>
                        <Field
                          name={`interestsCheck.${item.value}`}
                          component={Checkbox}
                          placeholder={item.label}
                          checked={`values.interestsCheck.${item.value}`}
                        />
                      </div>
                    );
                  })
                }
              </div>
              <div className="form-section">
                <div className="field-wrap">
                  <Field
                    name="message"
                    placeholder="Message"
                    component={TextArea} />
                </div>
              </div>
            </Fragment>)
            : (<Fragment>
              <div className="form-section">
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <div className="field-wrap">
                      <Field
                        name="name"
                        type="text"
                        placeholder="Contact Name"
                        component={Input}
                        isRequired={true} />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6">
                    <div className="field-wrap">
                      <Field
                        name="mobile_phone"
                        type="phone"
                        placeholder="Mobile Number"
                        component={Input}
                        phoneMask={true} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <div className="field-wrap">
                      <Field
                        name="email"
                        type="email"
                        placeholder="Email Address"
                        component={Input}
                        isRequired={true} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-section">
                <div className="field-wrap">
                  <Field
                    name="message"
                    placeholder="Message"
                    component={TextArea} />
                </div>
              </div>
            </Fragment>)
        }
        <div className="row justify-content-center">
          <div className="col-12 col-md-auto">
            <div className="field-wrap">
              <Button
                bgColor="green"
                type="submit"
                showLoader={isSending}>Send</Button>
            </div>
          </div>
        </div>
      </form>
    )
  }
}

export default compose(
  connect(
    (state) => {
      const { isSending, isSended } = state.contact;
      return { isSending, isSended };
    },
    {
      contactUs: ContactModule.contactUs,
    }
  ),
  withFormik({
    mapPropsToValues: (props) => {
      const { user } = props;

      return {
        client_type: "company",
        name: user.company_name || user.first_name || "",
        contact_name: user.contact_name || "",
        title: "",
        street: user.street_address || "",
        zip: user.zip || "",
        city: user.city || "",
        mobile_phone: user.phone || "",
        office_phone: "",
        email: user.email || "",
        message: "",
        interestsCheck: {},
      }
    },
    handleSubmit: (values, { props }) => {
      const { interestsCheck } = values;
      let interests = [];
      const itersetsId = Object.keys(interestsCheck);
      itersetsId && itersetsId.map((interest) => {
        if (interestsCheck[interest] === true) {
          interests.push(parseInt(interest))
        }
      });
      const sendData = { ...values, interests };
      if (values.client_type === "company") {
        delete sendData.interestsCheck;
        props.contactUs(sendData);
      } else {
        delete sendData.title;
        delete sendData.street;
        delete sendData.zip;
        delete sendData.city;
        delete sendData.office_phone;
        delete sendData.interests;
        delete sendData.interestsCheck;
        delete sendData.contact_name;
        props.contactUs(sendData);
      }
    },
    validationSchema: (props) => {

      return Yup.object().shape({
        name: Yup.string()
          .min(3, 'Too Short!')
          .max(64, 'Too Long!')
          .required('Required'),
        email: Yup.string()
          .email('Invalid email')
          .required('Required'),
        message: Yup.string()
          .min(10, 'At least 10 symbols')
          .max(255, 'Max length 255 symbols')
      })
    },
  }),
)(ContactForm);